import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import PageTracker from "@/components/PageTracker";
import ScrollToTop from "@/components/ScrollToTop";
import ImageFallback from "@/components/ImageFallback";
import Header from "@/components/Header";
import AnnouncementBanner from "@/components/AnnouncementBanner";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ResourcesLandingPage from "@/pages/ResourcesLandingPage";
import ResourcesPage from "@/pages/ResourcesPage";
import MovementResourcesPage from "@/pages/MovementResourcesPage";
import WellnessResourcesPage from "@/pages/WellnessResourcesPage";
import WholeSelfResourcesPage from "@/pages/WholeSelfResourcesPage";
import TestimonialsPage from "@/pages/TestimonialsPage";
import EventsPage from "@/pages/EventsPage";
import BlogPage from "@/pages/BlogPage";
import ContactPage from "@/pages/ContactPage";
import ProgramsPage from "@/pages/ProgramsPage";
import LearnFasciaPage from "@/pages/LearnFasciaPage";
import FasciaResetProgramPage from "@/pages/FasciaResetProgramPage";
import BackResetProgramPage from "@/pages/BackResetProgramPage";
import MetabolicQuizPage from "@/pages/MetabolicQuizPage";
import LifestyleAssessmentPage from "@/pages/LifestyleAssessmentPage";
import BodyAssessmentPage from "@/pages/BodyAssessmentPage";
import FoodPreferencesPage from "@/pages/FoodPreferencesPage";
import AdminPage from "@/pages/AdminPage";
import CrapCleansePage from "@/pages/CrapCleansePage";
import FeelGoodDetoxPage from "@/pages/FeelGoodDetoxPage";
import FlexDetoxPage from "@/pages/FlexDetoxPage";
import DoubleDownPage from "@/pages/DoubleDownPage";
import LifeNinjaGamePage from "@/pages/LifeNinjaGamePage";
import SurvivingToThrivingPage from "@/pages/SurvivingToThrivingPage";
import FourPillarsPage from "@/pages/FourPillarsPage";
import WellnessWheelPage from "@/pages/WellnessWheelPage";
import SlowWellnessPage from "@/pages/SlowWellnessPage";
import VIPPage from "@/pages/VIPPage";
import CoachingPage from "@/pages/CoachingPage";
import WellnessJournalPage from "@/pages/WellnessJournalPage";
import JillsCornerPage, { cornerCategories } from "@/pages/JillsCornerPage";
import CoachingResourcePage from "@/pages/CoachingResourcePage";
import TeamProgramPage from "@/pages/TeamProgramPage";
import FastBrainPage from "@/pages/FastBrainPage";
import Fifty2TuesdaysPage from "@/pages/Fifty2TuesdaysPage";
import ReadingRoomPage from "@/pages/ReadingRoomPage";
import StartHerePage from "@/pages/StartHerePage";
import MedicalDisclosurePage from "@/pages/MedicalDisclosurePage";
import LiabilityWaiverPage from "@/pages/LiabilityWaiverPage";
import NewClientPage from "@/pages/NewClientPage";
import ZoomPollPage from "@/pages/ZoomPollPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <ImageFallback />
        <PageTracker />
        <div className="min-h-screen flex flex-col bg-cream">
          <div className="sticky top-0 z-50">
            <AnnouncementBanner />
            <Header />
          </div>
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/resources" element={<ResourcesLandingPage />} />
              <Route path="/resources/recipes" element={<ResourcesPage />} />
              <Route path="/resources/movement" element={<MovementResourcesPage />} />
              <Route path="/resources/wellness" element={<WellnessResourcesPage />} />
              <Route path="/resources/whole-self" element={<WholeSelfResourcesPage />} />
              <Route path="/testimonials" element={<TestimonialsPage />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/programs" element={<ProgramsPage />} />
              <Route path="/learn/fascia" element={<LearnFasciaPage />} />
              <Route path="/programs/fascia-reset" element={<FasciaResetProgramPage />} />
              <Route path="/programs/back-reset" element={<BackResetProgramPage />} />
              <Route path="/programs/crap-cleanse" element={<CrapCleansePage />} />
              <Route path="/programs/feel-good-detox" element={<FeelGoodDetoxPage />} />
              <Route path="/programs/flex-detox" element={<FlexDetoxPage />} />
              <Route path="/programs/double-down" element={<DoubleDownPage />} />
              <Route path="/programs/life-ninja-game" element={<LifeNinjaGamePage />} />
              <Route path="/programs/surviving-to-thriving" element={<SurvivingToThrivingPage />} />
              <Route path="/programs/four-pillars" element={<FourPillarsPage />} />
              <Route path="/programs/terrain" element={<SlowWellnessPage />} />
              <Route path="/programs/terrain/wellness-wheel" element={<WellnessWheelPage />} />
              <Route path="/programs/vip" element={<VIPPage />} />
              <Route path="/programs/dignity-house" element={<TeamProgramPage programId="dignity-house" />} />
              <Route path="/programs/sbrc" element={<TeamProgramPage programId="sbrc" />} />
              <Route path="/programs/fast-brain" element={<FastBrainPage />} />
              <Route path="/programs/fifty2-tuesdays" element={<Fifty2TuesdaysPage />} />
              <Route path="/programs/vip/coaching" element={<CoachingPage />} />
              <Route path="/programs/vip/journal" element={<WellnessJournalPage categories={cornerCategories} />} />
              <Route path="/programs/vip/jills-corner" element={<JillsCornerPage />} />
              <Route path="/programs/vip/coaching/:id" element={<CoachingResourcePage />} />
              <Route path="/programs/vip/reading-room" element={<ReadingRoomPage />} />
              <Route path="/programs/vip/start-here" element={<StartHerePage />} />
              <Route path="/programs/vip/medical-disclosure" element={<MedicalDisclosurePage />} />
              <Route path="/programs/vip/liability-waiver" element={<LiabilityWaiverPage />} />
              <Route path="/journal" element={<WellnessJournalPage categories={cornerCategories} />} />
              <Route path="/programs/new-client" element={<NewClientPage />} />
              <Route path="/poll/zoom-times" element={<ZoomPollPage />} />
              <Route path="/quiz/metabolic-rhythm" element={<MetabolicQuizPage />} />
              <Route path="/quiz/lifestyle-assessment" element={<LifestyleAssessmentPage />} />
              <Route path="/quiz/body-assessment" element={<BodyAssessmentPage />} />
              <Route path="/quiz/food-preferences" element={<FoodPreferencesPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
